import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Lucía', 'Martina', 'Sofía', 'Valentina', 'Camila', 'Carolina', 'Florencia', 'Julieta', 'Agustina', 'María'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'San Miguel de Tucumán', 'Santa Fe', 'San Juan'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    // Loop
    const interval = setInterval(() => {
      // Random interval between 8 and 15 seconds + 4 seconds display time
      const randomDelay = Math.floor(Math.random() * 7000) + 8000;
      setTimeout(showNotification, randomDelay);
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: 100,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 right-4 z-50 max-w-sm w-full sm:w-auto" data-id="element-2">
          <div className="bg-white rounded-lg shadow-xl border border-slate-100 p-4 flex items-center gap-3" data-id="element-3">
            <div className="flex-shrink-0" data-id="element-4">
              <div className="h-10 w-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-5">
                <CheckCircle2 className="h-6 w-6 text-green-600" data-id="element-6" />
              </div>
            </div>
            <div data-id="element-7">
              <p className="text-sm font-medium text-slate-900" data-id="element-8">
                {notification.name} de {notification.city}
              </p>
              <p className="text-xs text-slate-500" data-id="element-9">
                acaba de comprar{' '}
                <span className="font-semibold text-amber-600" data-id="element-10">
                  ENERGÍA REAL
                </span>
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}